
import React from "react";
import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";

interface MobileNavItemProps {
  name: string;
  link: string;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  highlight?: boolean;
}

const MobileNavItem: React.FC<MobileNavItemProps> = ({ 
  name, 
  link, 
  className, 
  onClick,
  highlight = false
}) => {
  return (
    <NavLink
      to={link}
      className={({ isActive }) =>
        cn(
          "text-lg font-medium block w-full px-4 py-3 rounded-lg transition-colors mobile-touch-target text-left",
          isActive
            ? "text-primary bg-primary/5 font-semibold"
            : highlight 
              ? "text-primary bg-primary/5 hover:bg-primary/10" 
              : "text-white hover:text-primary hover:bg-joerg-800/70",
          className
        )
      }
      onClick={onClick}
      end
    >
      {name}
    </NavLink>
  );
};

export default MobileNavItem;
